import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ArrowUpRight } from "lucide-react";
import { COMPANY, NAV, SERVICES } from "../mock";
import { SERVICE_AREAS } from "../data/serviceAreas";
import { useEstimate } from "./EstimateContext";

export default function Footer() {
  const { openEstimate } = useEstimate();
  return (
    <footer className="bg-[#0f2740] text-white">
      <div className="container-x py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img src="/assets/logo.png" alt="logo" className="w-12 h-12 object-contain bg-white rounded-xl p-1.5" />
              <div className="leading-tight">
                <div className="font-display font-bold">CLASSIC INTERIOR</div>
                <div className="text-[11px] tracking-[0.22em] text-[#7fb8de]">RENOVATIONS LTD</div>
              </div>
            </div>
            <p className="text-[#a9c6dd] text-sm leading-relaxed mb-5">
              Edmonton-based renovation company specializing in kitchens, bathrooms, basements and custom interior projects built to last.
            </p>
            <button onClick={openEstimate} className="inline-flex items-center gap-2 text-[#2f9fe6] font-semibold hover:gap-3 transition-all">
              Get an Estimate <ArrowUpRight className="w-4 h-4" />
            </button>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-5 text-white">Company</h4>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.label}>
                  <Link to={n.to} className="text-[#a9c6dd] hover:text-white transition-colors text-sm">{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-5 text-white">Services</h4>
            <ul className="space-y-3">
              {SERVICES.slice(0, 5).map((s) => (
                <li key={s.slug}>
                  <Link to="/services" className="text-[#a9c6dd] hover:text-white transition-colors text-sm">{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-5 text-white">Service Areas</h4>
            <ul className="space-y-3">
              {SERVICE_AREAS.slice(0, 6).map((a) => (
                <li key={a.slug}>
                  <Link to={`/service-areas/${a.slug}`} className="text-[#a9c6dd] hover:text-white transition-colors text-sm">{a.name}</Link>
                </li>
              ))}
              <li>
                <Link to="/service-areas" className="text-[#2f9fe6] hover:text-white transition-colors text-sm font-semibold">All areas →</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-5 text-white">Get in touch</h4>
            <ul className="space-y-4 text-sm">
              {COMPANY.contacts.map((c) => (
                <li key={c.name} className="flex items-start gap-3"><Phone className="w-4 h-4 text-[#2f9fe6] mt-0.5" /><a href={c.href} className="text-[#a9c6dd] hover:text-white">{c.phone} <span className="text-[#6b7f96]">· {c.name}</span></a></li>
              ))}
              <li className="flex items-start gap-3"><Mail className="w-4 h-4 text-[#2f9fe6] mt-0.5" /><a href={`mailto:${COMPANY.email}`} className="text-[#a9c6dd] hover:text-white break-all">{COMPANY.email}</a></li>
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-[#2f9fe6] mt-0.5" /><span className="text-[#a9c6dd]">{COMPANY.city}</span></li>
              <li className="flex items-start gap-3"><Clock className="w-4 h-4 text-[#2f9fe6] mt-0.5" /><span className="text-[#a9c6dd]">{COMPANY.hours}</span></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-[#7f9bb3]">
          <p>© {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.</p>
          <p>Built for the way you live.</p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-4 text-center text-xs text-[#6b7f96]">
          Website by{" "}
          <a
            href="https://webempire.ca/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#a9c6dd] hover:text-[#2f9fe6] font-medium transition-colors"
            data-testid="footer-developer-link"
          >
            WebEmpire
          </a>
        </div>
      </div>
    </footer>
  );
}
